import styled, { css } from "styled-components"
import { colors } from "../../../lib/colors"
import { tabletMediumText } from "../../../media_queries/TabletMediaQueries"

import {
  win_notification_body,
  moveDown,
  moveRight,
  moveup,
  moveDownOne,
  moveDownTwo,
  jackpotAnim,
} from "./winNotificationHelpers"

export const WinNotificationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  /* gap: 10px; */
  z-index: 1;
  position: absolute;
  width: 100%;
  top: -60px;
`

export const WinNotificationBody = styled.div<win_notification_body>`
  display: flex;
  display: ${({ which, move }) =>
    which === 0 && !move.moveOne && move.moveTwo ? "none" : "flex"};
  justify-content: center;
  align-items: center;
  /* position: absolute;
  bottom: 0; */
  margin-left: 10px;
  position: relative;
  /* left: ${({ which, move }) =>
    which === 0 ? "50%" : `calc(50% + 65px)`}; */
  /* transform: translate(-50%, 0); */
  min-width: 108px;
  animation: ${
    ({ length, which, move }) =>
      length === 1 && move.moveOne
        ? css`
            ${moveup} 0.3s forwards
          `
        : length === 1
        ? css`
            ${moveDown} 0.3s forwards
          `
        : which === 1 && !move.moveTwo
        ? css`
            ${moveDownOne} 0.3s forwards
          `
        : length === 2 && !move.moveOne && !move.moveTwo
        ? css`
            ${moveDownTwo} 0.3s forwards
          `
        : which !== 0
        ? css`
            ${moveup} 0.3s forwards
          `
        : // which !== 0
          // ?
          css`
            ${moveup} 0.3s forwards
          `
    // : css`
    //     ${moveRight} 0.3s forwards
    // `
  };

  background-color: ${colors.winBoxBackground};
  border-radius: 4px;
  padding: 5px 6px;
  h1,
  span,
  p {
    text-transform: uppercase;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 100%;
    color: ${colors.liveBetsGreen};
    ${tabletMediumText}
  }
`

export const JackpotWinStyles = styled.div<{ color: any }>`
  display: flex;
  align-items: center;
  text-transform: uppercase;
  background-color: ${({ color }) =>
    color === "blue"
      ? colors.jackpotWinBlueBackground
      : color === "red"
      ? colors.jackpotWinRedBackground
      : colors.jackpotWinYellowBackground};
  border-radius: 4px;
  padding: 2px 8px;
  position: relative;
  /* animation: ${jackpotAnim} 1s forwards;
  opacity: 0; */
  div {
    height: unset !important;
    position: absolute;
    left: -1px;
    top: 0;
  }
  img {
    width: 21px !important;
    height: 24px !important;
  }
  span {
    margin-left: 8px;
    color: ${({ color }) =>
      color === "blue"
        ? colors.jackpotWinBlue
        : color === "red"
        ? colors.jackpotWinRed
        : colors.jackpotWinYellow};
  }
`
